import styled from 'styled-components';

export const ErrorBoundaryWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 70%;
  margin-top: 100px;
`;

export const Card = styled.div`
  min-height: unset;
  flex-direction: column;
`;
export const Title = styled.div`
  font-family: 'Oswald';
  font-size: 22px;
  padding-bottom: 8px;
  text-transform: uppercase;
  font-weight: 500;
`;
